import { ReactNode, useEffect } from 'react'
import { COMPONENTS_DRAWER_TEXTS as T } from '../../shared/texts'

// Right-side slide-in drawer (the app's standard overlay container). Header + footer
// stay fixed; the body scrolls, so content taller than the viewport is always
// reachable. Click on the backdrop or Escape closes it.
export default function Drawer({ open, title, onClose, children, footer, action, width }: {
    open: boolean
    title: ReactNode
    onClose: () => void
    children: ReactNode
    footer?: ReactNode
    action?: ReactNode // optional control(s) shown in the header, left of the close ×
    width?: number
}) {
    useEffect(() => {
        if (!open) return
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [open, onClose])
    if (!open) return null
    return (
        <div className="drawer-backdrop" onMouseDown={onClose}>
            <aside className="drawer" role="dialog" aria-modal="true"
                style={width ? { width: `min(${width}px, 94vw)` } : undefined}
                onMouseDown={(e) => e.stopPropagation()}>
                <header className="drawer-head">
                    <h2>{title}</h2>
                    <div className="drawer-head-actions">
                        {action}
                        <button type="button" className="icon-action" aria-label={T.close} onClick={onClose}>×</button>
                    </div>
                </header>
                <div className="drawer-body">{children}</div>
                {footer && <div className="drawer-foot">{footer}</div>}
            </aside>
        </div>
    )
}
